import { gql } from "@apollo/client";

const STUDENT_RESEND_CONFIRMATION = gql`
  mutation ResendConfirmation($email: String!, $redirectUrl: String!) {
    studentResendConfirmationWithToken(
      email: $email
      confirmUrl: $redirectUrl
    ) {
      message
    }
  }
`;

export default STUDENT_RESEND_CONFIRMATION;
